import { Component, OnInit, OnChanges } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { SpinnerComponent } from '../shared/spinner/spinner.component';
import { MessagingService } from '../../services/messaging/messaging.service';
import { filter } from 'rxjs/operators';
import { AnalyticsBean } from 'src/app/beans/analytics/analytics-module.bean';
import { EheAnalyticsDirective } from '../shared/ehe-analytics/ehe-analytics.directive';

/**
 * Messaging component
 */
@Component({
	selector: 'app-messaging',
	templateUrl: './messaging.component.html',
	styleUrls: ['./messaging.component.scss'],
	providers: [EheAnalyticsDirective],
})
/**
 * Messaging component
 */
export class MessagingComponent implements OnInit {
	/**
	 * Holds message count
	 */
	messageCount: any;
	/**
	 * contains redirect url
	 */
	redirect: any;
	/**
	 * Holds analytics data
	 */
	analyticsData: AnalyticsBean;
	/**
	 * Messaging component constructor
	 * @param spinner Spinner service
	 * @param messagingService Messaging service
	 * @param router Angular router
	 */
	constructor(
		private spinner: SpinnerComponent,
		public messagingService: MessagingService,
		private router: Router
	) {
		this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
			this.redirect = btoa(JSON.stringify(event.url));
		});
		this.analyticsData = new AnalyticsBean();
		this.analyticsData.componentName = 'Messaging';
		this.analyticsData.pageUrl = '/messaging/mailbox/inbox';
	}

	/**
	 * Component initialization
	 */
	ngOnInit() {
		this.getMessageCount();
	}

	/**
	 * Gets message count by folder
	 */
	getMessageCount() {
		this.spinner.startLoader();
		this.messagingService.getMessageCount().subscribe(
			response => {
				this.spinner.stopLoader();
				// setting the message count to the Observable for further use
				this.messagingService.setCurrentMessageCount(response);
			},
			err => {
				this.spinner.stopLoader();
				console.error(`[${MessagingComponent.name}][${this.getMessageCount.name}]`, err);
			}
		);
	}

	/**
	 * Redirects based on redirect url
	 */
	redirectToCompose() {
		this.analyticsData.id = 'Compose message';
		this.analyticsData.redirectedTo = '/messaging/compose';
		this.analyticsData.placement = 'Messaging compose';
		this.router.navigate(['/messaging/compose'], {
			queryParams: { redirect: this.redirect },
		});
	}
}
